/**
 * @file   src\components\CWFooter.tsx
 * @brief  Footer component.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import '../components/CWFooter.scss';

const CWFooter = () => {
  return (
      <div className="footer text-center d-flex align-items-center justify-content-center">
        <p>2024 Car Wash App. All rights reserved.</p>
      </div>
  );
};
export default CWFooter;
